"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerSymbol = exports.SYMBOL_FOR_COLOR = void 0;
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
exports.SYMBOL_FOR_COLOR = {
    red: '▲',
    blue: '+',
    black: '∇',
    yellow: '∗',
    green: '◆',
    purple: '◉',
    orange: '▢',
    pink: '◈',
    bronze: '▦',
    neutral: '★',
};
function playerSymbol(color, optionalSuffix = '') {
    if ((0, PreferencesManager_1.getPreferences)().symbol_overlay) {
        return exports.SYMBOL_FOR_COLOR[color] + optionalSuffix;
    }
    return '';
}
exports.playerSymbol = playerSymbol;
